<mat-chip
  class="ms-0 advanced-filter-chip"
  [style]="{ height: '48px' }"
  [class]="dateFilter().isInvalid() ? 'red' : ''"
  [removable]="true"
  (removed)="removeClick.emit()"
  (mouseover)="hoveredFilterIdentityUpdate.emit({ field: dateFilter().field, operator: dateFilter().operator })"
  (mouseleave)="hoveredFilterIdentityUpdate.emit(null)"
  (click)="onChipClick()"
>
  <span>{{ label() }}</span>
  <mat-icon matChipRemove>cancel</mat-icon>
</mat-chip>
